import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-two-option-alert',
  templateUrl: './two-option-alert.component.html',
  styleUrls: ['./two-option-alert.component.css'],
})
export class TwoOptionAlertComponent implements OnInit {
  toggleValue: boolean = true;

  constructor(
    public matDialogRef: MatDialogRef<TwoOptionAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any,
  ) {}

  ngOnInit(): void {
    if (this.data?.toggleDefaultValue !== undefined) {
      this.toggleValue = this.data.toggleDefaultValue;
    }
  }

  buttonOne() {
    this.matDialogRef.close(0);
  }

  buttonTwo() {
    if (this.data?.hasToggle) {
      this.matDialogRef.close({ option: 1, toggleValue: this.toggleValue });
    } else {
      this.matDialogRef.close(1);
    }
  }

  buttonThree() {
    this.matDialogRef.close(2);
  }
}
